import { render, staticRenderFns } from "./pdfTemplate2.vue?vue&type=template&id=0a54c99b&scoped=true"
import script from "./pdfTemplate2.vue?vue&type=script&lang=js"
export * from "./pdfTemplate2.vue?vue&type=script&lang=js"
import style0 from "./pdfTemplate2.vue?vue&type=style&index=0&id=0a54c99b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a54c99b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a54c99b')) {
      api.createRecord('0a54c99b', component.options)
    } else {
      api.reload('0a54c99b', component.options)
    }
    module.hot.accept("./pdfTemplate2.vue?vue&type=template&id=0a54c99b&scoped=true", function () {
      api.rerender('0a54c99b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/deliveryNote/components/pdfTemplate2.vue"
export default component.exports